"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.796 8.08a.494.494 0 0 0-.046-.184.488.488 0 0 0-.19-.221L2.444.557l-.49-.288a.501.501 0 0 0-.733.575l.047.152.05.17.48 1.592L3.38 8.016l-.035.116-1.632 5.423.085-.05 1.269-.746.047-.029L4.34 8.657l.016-.051h4.39v-1H4.3L3.068 3.504l-.48-1.591-.04-.136 10.72 6.299-.094.056L2.588 14.35l-1.27.744-.112.067.062.105.064.11a.835.835 0 0 0 1.112.328L14.56 8.588a.483.483 0 0 0 .19-.221.49.49 0 0 0 .046-.184c0-.017.004-.034.003-.051 0-.018-.002-.034-.003-.052"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.835 11.72 2.735.5a.564.564 0 0 0-.823.646l3.333 11.079-2.788 9.266 1.4-.823 2.377-7.9h6.879v-1.125H6.244L3.402 2.196 20.45 12.212 2.17 22.952l-.08.046.047.081a1 1 0 0 0 .873.5c.177 0 .353-.048.51-.14l18.268-10.734.041-.024.027-.015.054-.033-.008-.013c.047-.04.1-.073.133-.13a.562.562 0 0 0-.2-.77"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.113 15.627 3.647.665a.751.751 0 0 0-1.098.863L6.993 16.3 3.276 28.654l1.866-1.096 3.17-10.535h9.172v-1.5H8.326L4.536 2.928l22.731 13.355-24.373 14.32-.107.063.063.108c.182.31.474.53.823.62a1.338 1.338 0 0 0 1.02-.142l24.358-14.31.055-.032.036-.021.072-.044-.011-.018c.063-.053.133-.096.177-.172a.75.75 0 0 0-.267-1.027"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.022 23.602 4.928.633a.937.937 0 0 0-1.373 1.079l6.83 22.699-5.932 19.713 2.379-1.397 5.229-17.379h14.271v-1.875H12.061L6.04 3.462 41.696 24.41 3.978 46.57a1.876 1.876 0 0 0 2.566.667l37.478-22.02v-.002a.937.937 0 0 0 0-1.614"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.696 31.47 6.571.845A1.25 1.25 0 0 0 4.74 2.283l9.106 30.265-7.908 26.285L9.11 56.97l6.972-23.172h19.03v-2.5H16.08L8.053 4.616l47.542 27.932-50.29 29.547a2.5 2.5 0 0 0 3.421.889l49.97-29.36v-.002c.176-.104.333-.251.444-.441a1.25 1.25 0 0 0-.444-1.711"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSend = function IconSend(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Send' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Send"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSend.sizes = [16, 24, 32, 48, 64];
IconSend.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSend;
exports.default = _default;